import { defineStore } from "pinia"
import { reactive, ref, computed } from "vue"

export const useEnvStore = defineStore("env", () => {
  const state = reactive({
    ua: "",
    isMobile: false,
    size: {
      panelHeight: 1080-64-32,
      width: 1920,
      height: 1080,
    },
  })

  const isMobile = computed(() => state.isMobile)
  const size = computed(() => state.size)
  const ua = computed(() => state.ua)
  const wechatWork = computed(() => /wxwork/i.test(state.ua.toLowerCase()))
  const wechat = computed(()=> /micromessenger/i.test(state.ua.toLowerCase()))
  const ios = computed(()=> /ipod/i.test(state.ua.toLowerCase()) || /ipad/i.test(state.ua.toLowerCase()) || /iphone/i.test(state.ua.toLowerCase()))
  const testing = computed(()=> window.eightcatty.cmd.indexOf("testing") >= 0)
  const noalipay = computed(()=> window.eightcatty.cmd.indexOf("noalipay") >= 0)
  const feature = computed(() => {
    return {
      wechatWork: false
    }
  })

  const setMobile = (isMobile: boolean) => {
    state.isMobile = isMobile
  }

  const setSize = (width: number, height: number) => {
    state.size = {
      panelHeight: height - 64 - 32, //减去header+footer高度
      width: width,
      height: height
    }
  }

  const setUerAgent = (userAgent: string) => {
    state.ua = userAgent
  }

  

  return {
    feature,
    isMobile,
    size,
    ua,
    wechatWork,
    wechat,
    ios,
    testing,
    noalipay,
    setMobile,
    setSize,
    setUerAgent,
  }

})